import UiVersionSwitcher from '@/components/ui/custom/UiVersionSwitcher';
import DeprecatedTeacherDashboardView from '@/pages/_deprecated/TeacherDashboardView';
import TeacherDashboardView from '@/pages/dashboard/TeacherDashboardView';

export default function TeacherDashboardViewSwitcher() {
  return (
    <UiVersionSwitcher scope="teacherDashboard">
      <UiVersionSwitcher.Legacy>
        <DeprecatedTeacherDashboardView />
      </UiVersionSwitcher.Legacy>
      <UiVersionSwitcher.Modern>
        <TeacherDashboardView />
      </UiVersionSwitcher.Modern>
    </UiVersionSwitcher>
  );
}
